"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
/* eslint-disable no-console */
const isError_1 = __importDefault(require("lodash/isError"));
const omitBy_1 = __importDefault(require("lodash/omitBy"));
exports.Logger = new (class {
    constructor() {
        this._logger = console;
    }
    dissect(data = {}) {
        let errors = [];
        let dataWithoutErrors = {};
        if ((0, isError_1.default)(data)) {
            errors = [data];
        }
        else if (typeof data === 'string') {
            dataWithoutErrors = { data };
        }
        else {
            errors = Object.values(data).filter(v => (0, isError_1.default)(v));
            dataWithoutErrors = (0, omitBy_1.default)(data, v => (0, isError_1.default)(v));
        }
        return { dataWithoutErrors, errors };
    }
    debug(message, data) {
        if (typeof data === 'string')
            data = { data };
        this._logger.log(stringify(message, data));
    }
    info(message, data) {
        if (typeof data === 'string')
            data = { data };
        this._logger.log(stringify(message, data));
    }
    warn(message, data) {
        if (typeof data === 'string')
            data = { data };
        this._logger.warn(stringify(message, data));
    }
    error(message, data) {
        const { dataWithoutErrors, errors } = this.dissect(data);
        this._logger.error(stringify(message, dataWithoutErrors));
        errors.forEach(e => this._logger.error(e));
    }
    sql(sql, params, maxLength = 200) {
        this._logger.log(sql
            .trim()
            .split('\n')
            .join(' ')
            .split('\t')
            .join(' ')
            .split('      ')
            .join(' ')
            .split('    ')
            .join(' ')
            .split('    ')
            .join(' ')
            .split('  ')
            .join(' ')
            .split('  ')
            .join(' ')
            .split('  ')
            .join(' ')
            .split('  ')
            .join(' ')
            .split('  ')
            .join(' ')
            .substr(0, maxLength), params);
    }
})();
exports.default = exports.Logger;
function stringify(message, data) {
    if (!data)
        return message;
    return `${message}\n${JSON.stringify(data, null, 2)}`.split('\n').join('\n ');
}
